export default __webpack_public_path__ + "static/media/water.2e85de33.svg";